export const SearchParticipantFormKey = {
  participantNameFilter: "participantNameFilter",
  participantName: "participantName",
  programNameFilter: "programNameFilter",
  programName: "programName",
  clientNameFilter: "clientNameFilter",
  clientName: "clientName",
  productLine: "productLine",
  programTemplate: "programTemplate",
  status: "status",
  deliveryCountry: "deliveryCountry",
  deliveryOfficeFilter: "deliveryOfficeFilter",
  deliveryOffice: "deliveryOffice",
  coachFilter: "coachFilter",
  coach: "coach",
  createdDate: "createdDate",
} as const;

export interface CoachesType {
  coachId: string;
  coachFirstName: string;
  coachLastName: string;
}
export interface SearchParticipantResult {
  participantId: string;
  participantName?: string;
  participantFirstName: string;
  participantLastName: string;
  programId: string;
  programName: string;
  clientId: string;
  clientName: string;
  lobId: string;
  lobName: string;
  programTemplateName: string;
  programTemplateId: string;
  status: string;
  deliveryCountryCode: string;
  deliveryCountryName: string;
  deliveryOfficeName: string;
  coachId: string;
  coachFirstName: string;
  coachLastName: string;
  coach?: string;
  coaches: CoachesType[];
  createdTimeStamp: string;
  isSelected?: boolean;
  nextProgramClassId: string;
  nextProgramClassName: string;
  [key: string]: any;
}
export interface SelectedParticipantResultType extends SearchParticipantResult {
  notes?: string;
  nextProgramClass?: string;
  failureReason?: string;
  deliveryCountry?: string;
  productLine?: string;
  deliveryOffice?: string;
}
export const SearchParticipantResultFormKey = {
  isSelected: "isSelected",
  participantName: "participantName",
  programName: "programName",
  clientName: "clientName",
  companyName: "companyName",
  lobName: "lobName",
  programTemplateName: "programTemplateName",
  status: "status",
  deliveryCountryName: "deliveryCountryName",
  deliveryOfficeName: "deliveryOfficeName",
  coach: "coach",
  coachesList: "coachesList",
  createdDate: "createdDate",
  nextProgramClassName: "nextProgramClassName",
  notes: "notes",
} as const;

export const ActivitiesResultFormKey = {
  activityType: "activityType",
  activityTypeName: "activityTypeName",
  modalityName: "modalityName",
  modality: "modality",
  topic: "topic",
  defaultDurationInMinutes: "defaultDurationInMinutes",
  actualDurationInMinutes: "actualDurationInMinutes",
  defaultDurationMinsName: "defaultDurationMinsName",
  actualDurationMinsName: "actualDurationMinsName",
  onBehalfOfCoachName: "onBehalfOfCoachName",
  notes: "notes",
  activityDate: "activityDate",
} as const;

export interface TopicResponseType {
  id: string;
  topic: string;
}

export interface ActivityItemType {
  id: number;
  activityType: string;
  modality: string;
  topic: TopicResponseType[];
  actualDurationInMinutes: string;
  onBehalfOfCoachId: string;
  onBehalfOfCoachName: string;
  notes: string;
  defaultDurationInMinutes: string;
  activityDate: string;
  activityTypeName?: string;
  modalityName?: string;
  actualDurationMinsName?: string;
  defaultDurationMinsName?: string;
  systemDate?: string;
  [key: string]: any;
}

export interface IdNameType {
  id: string;
  name: string;
}

export interface ParticipantResponse {
  programId: string;
  programName: string;
  participantId: string;
  participantName: string;
  clientId: string;
  clientName: string;
  lobId: string;
  programTemplateId: string;
  programTemplateName: string;
  status?: string;
  nextProgramClass?: string;
  failureReason?: string;
  deliveryCountry?: string;
  productLine?: string;
  deliveryOffice?: string;
}

export interface UnprocessedParticipantResponse extends ParticipantResponse {
  failureReason?: string;
}

export interface ParticipantData {
  totalParticipants: number;
  processedParticipants: number;
  unProcessedParticipants: number;
  activitites: number;
  processedResponse: ParticipantResponse[];
  unProcessedResponse: UnprocessedParticipantResponse[];
}

export const CreateBulkActivityFormKey = {
  bulkProcessName: "bulkProcessName",
};
